<h2 class="text-center mb-4">Email confirmation</h2>
<p class="text-center" *ngIf="!successMessage && !errorMessage" role="status">Please wait while we check your email. <br>This will be quick...</p>
<p class="alert text-center alert-warning font-weight-bold" *ngIf="errorMessage" role="alert">{{errorMessage}}</p>
<p class="alert text-center alert-success font-weight-bold" *ngIf="successMessage" role="status">{{successMessage}}</p>
<p class="text-links-wrap" *ngIf="this.tokenSet"><a routerLink="/" class="text-link m-auto">Click here to continue</a></p>
<p class="text-links-wrap" *ngIf="errorMessage">
  <a routerLink="/access/login" class="text-link">Back to login</a>
  <a routerLink="/access/resendemailverification" class="text-link text-right">Resend verification email</a>
</p>
